/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import { NullEnum } from './nullEnum';
import { PetTypeEnum } from './petTypeEnum';

/**
 * @nullable
 */
export type SeoLocationDetailsPetType = PetTypeEnum | NullEnum | null;

export const SeoLocationDetailsPetType = { ...PetTypeEnum, ...NullEnum } as const;
